// extracted by mini-css-extract-plugin
export default {"container":"SendCodePage_container__YoxrA"};